import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppFuncionesService } from 'src/app/app-funciones/app-funciones.service';
import { Kardex } from 'src/app/modelos/kardex';
import { KardexService } from 'src/app/services/kardex.service';

export class IntervinienteL{
  
 nombres:String = '';
 numeroPartida:string = '';
 numeroDocumento:string = '';

}

@Component({
  selector: 'app-legalizacion-firma-qr',
  templateUrl: './legalizacion-firma-qr.component.html',
  styleUrls: ['./legalizacion-firma-qr.component.css']
})
export class LegalizacionFirmaQrComponent implements OnInit {

  id:string = '7ba7ec6f-7120-6541-9ce4-55746b6a06cc';
  show:boolean = false;

  contratantes:any;

  kardex: Kardex = new Kardex();
  Modelo:number = 1;

  representante: IntervinienteL = new IntervinienteL();
  empresa:IntervinienteL = new IntervinienteL();
  representantes:any;

  recepcion:string = '';

  constructor(private rutaActiva: ActivatedRoute,private kardexService:KardexService,
    private appFuncionesService:AppFuncionesService, private spinner: NgxSpinnerService) { }

  ngOnInit() {

  
    this.spinner.show();
    this.kardexService.GetByCuid(this.rutaActiva.snapshot.params.id).subscribe(response => {
      this.spinner.hide();
      this.kardex.fechaIngreso = response.kardexs[0].fechaIngreso;
      this.kardex.ubicacionFirma = response.kardexs[0].ubicacionFirma;
      this.kardex.numKardex = response.kardexs[0].numKardex;
      this.kardex.recepcion = response.kardexs[0].recepcion;
      this.contratantes = response.contratantes;

    

      let arrContratantePJ = this.contratantes.filter(item => {
        return item.tipoPersona == 'J';
      }); 

      

      if(arrContratantePJ.length == 1){
        this.Modelo = 2;
        this.empresa.nombres = arrContratantePJ[0].cliente;
        this.empresa.numeroDocumento = arrContratantePJ[0].numeroDocumento;
        this.empresa.numeroPartida = arrContratantePJ[0].numeroPartida;
        let arrContratantePN = this.contratantes.filter(item => {
          return item.tipoPersona == 'N';
        });

        this.representantes = arrContratantePN;

        /*if(arrContratantePN.length == 1){
          this.representante.nombres = arrContratantePN[0].cliente;
          this.representante.numeroDocumento = arrContratantePN[0].numeroDocumento;
          this.representante.numeroPartida = arrContratantePN[0].numeroPartida;
        }*/
        
      }
      



    });
  }

}
